import { useCreateSchemaDefinitionMutation } from "../../gateways/cms/schemaApi";
import MainLayout from "../../layouts/MainLayout";
import { SchemaDefinitionForm } from "../../components/SchemaDefinitionForm";
import { SchemaDefinitionFormRequest as SchemaDefinitionFormData } from "../../gateways/cms/schema";
import { useNavigate } from "react-router-dom";

import { styled } from "@mui/system";

// style
const PageTitle = styled("section")`
    display: flex;
    justify-content: space-between;
    padding: 24px;
    // margin-bottom: 16px;

    h1 {
        font-size: 24px;
        font-weight: normal;
        margin: 0;
    }
`;

export function SchemaDefinitionCreatePage() {
    const navigate = useNavigate();
    const [schemaDefinitionCreate] = useCreateSchemaDefinitionMutation();

    const handleSubmit = async (data: SchemaDefinitionFormData) => {
        await schemaDefinitionCreate(data);
        navigate(-1);
    };

    return (
        <MainLayout title="コンテンツスキーマ管理（通常スキーマ作成）">
            <PageTitle>
                <h1>コンテンツスキーマ管理（通常スキーマ作成）</h1>
            </PageTitle>

            <SchemaDefinitionForm onSubmit={handleSubmit} />
        </MainLayout>
    );
}
